import {pageInfo, initPage, saveData,initUpdate, editData,deleteData,exportData, epodSubmit, podShow, orderBasicDetailsInfo} from './../api';
import {selectOrderStatus} from "../../../../api";
const epod = {
  namespaced: true,
  state: {
    total:0,
    pageResp:null,
    addResp: null,
    editResp: null,
    initPageObj: null,
    initUpdateObj: null,
    deleteResp: null,
    exportObj: null,
    epodSubmitResp: null,
    podShowRes: null,
    orderStatusObj: null,
    orderBasicInfoObj: null
  },
  mutations: {

    PAGE_INFO(state,data){
      state.pageResp = (data.obj || []).map(item =>({ ...item,
        btns: [
          {
            disabled: !(((item.orderTypeCode === '40' || item.orderTypeCode === '50' || item.orderTypeCode === '60') && item.schOrderStatusCode === 'RO404') || (item.orderTypeCode != '40' && item.orderTypeCode != '50' && item.orderTypeCode != '60')),
          },
          {
            disabled: !(item.epodStatusCode === 'esc20')
          }
        ]
        }));
     // state.pageResp = data.obj || [];
      state.total = data.total;

    },
    INIT_PAGE(state,data) {
      state.initPageObj = data.obj || {};
    },
    SAVE_DATA(state,data){
      state.addResp = data;
    },
    INIT_UPDATE(state,data) {
      state.initUpdateObj = data.obj || {};
    },
    EDIT_DATA(state,data){
      state.editResp = data;
    },
    DELETE_DATA(state,data){
      state.deleteResp = data;
    },
    EXPORT_DATA(state, data) {
      state.exportObj = data;
    },
    EPOD_SUBMIT(state, data) {
      state.epodSubmitResp = data;
    },
    POD_SHOW(state, data) {
      state.podShowRes = data;
    },
    ORDER_STATUS(state,data){
      state.orderStatusObj = data.obj || {};
    },
    ORDERBASIC_DETAILS_INFO(state, resp) {
      state.orderBasicInfoObj = resp.obj || {};
    },
  },
  actions: {
    //查询事件
    async pageInfo({commit}, obj){
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    //初始化页面事件
    async initPage({commit}, obj){
      let resp = await initPage(obj);
      commit('INIT_PAGE', resp);
    },
    //新增保存事件
    async saveData({commit}, obj){
      let resp = await saveData(obj);
      commit('SAVE_DATA', resp);
    },
    //初始化更新对象事件
    async initUpdate({commit}, obj){
      let resp = await initUpdate(obj);
      commit('INIT_UPDATE', resp);
    },
    //修改保存事件
    async editData({commit}, obj){
      let resp = await editData(obj);
      commit('EDIT_DATA', resp);
    },
    //删除数据事件
    async deleteData({commit}, obj){
      let resp = await deleteData(obj);
      commit('DELETE_DATA', resp);
    },

    //导出数据
    async exportData({ commit }, obj) {
      let resp = await exportData(obj);
      commit('EXPORT_DATA', resp);
    },
    //订单回单上传
    async epodSubmit({ commit }, obj) {
      let resp = await epodSubmit(obj);
      commit('EPOD_SUBMIT', resp);
    },
    //回单预览
    async podShow({ commit }, obj) {
      let resp = await podShow(obj);
      commit('POD_SHOW', resp);
    },
    async selectOrderStatus({commit}, obj){
      let resp = await selectOrderStatus(obj);
      commit('ORDER_STATUS', resp);
    },
    //基本信息
    async orderBasicDetailsInfo({ commit }, obj) {
      let resp = await orderBasicDetailsInfo(obj);
      commit('ORDERBASIC_DETAILS_INFO', resp);
    },
  }
}
export default epod



// WEBPACK FOOTER //
// ./src/page/transport/epod/store/epod.store.js